import React, { useEffect, useState, memo } from 'react'
import { csv } from "d3-fetch";
import {
    ComposableMap,
    Geographies,
    Geography,
    Sphere,
    Graticule
} from "react-simple-maps";
import Tooltip from '@mui/material/Tooltip';

const geoUrl = "/features.json";

const MapChart = ({countries }) => {

    return (
        <>
            <ComposableMap className="CMap" projection="geoEqualEarth">
                <Sphere stroke="#DDD" />
                <Graticule stroke="#DDD" />
                <Geographies geography={geoUrl} fill="#000" strokeWidth={0.5}>
                    {({ geographies }) =>
                        geographies.map((geo) => {
                            const isHighlightedgreen = countries.Highlightedgreen.indexOf(geo.id) !== -1;
                            const isHighlightedyellow = countries.Highlightedyellow.indexOf(geo.id) !== -1;
                            const isHighlightedorange = countries.Highlightedorange.indexOf(geo.id) !== -1;
                            const isHighlightedpurple = countries.Highlightedpurple.indexOf(geo.id) !== -1;
                            return (
                                <Tooltip title={countries.Highlightedgreen.includes(geo.id) || countries.Highlightedorange.includes(geo.id) || countries.Highlightedyellow.includes(geo.id) || countries.Highlightedpurple.includes(geo.id)
                                    ? `${geo.properties.name}` : ""}>
                                    <Geography
                                        key={geo.rsmKey}
                                        geography={geo}

                                        fill={
                                            isHighlightedgreen
                                                ? "#44b64d"
                                                : isHighlightedorange
                                                    ? "#ff8730"
                                                    : isHighlightedyellow
                                                        ? "#fad52f"
                                                        : isHighlightedpurple
                                                            ? "#c341eb"
                                                            : "#817d7d70"
                                        }
                                        style={{
                                            hover: {
                                                fill: isHighlightedgreen ? "#23752a"
                                                    : isHighlightedorange ? "#bf5406"
                                                        : isHighlightedyellow ? "#c2a006"
                                                            : isHighlightedpurple ? "#8909b0"
                                                                : "#817d7d70"
                                            },
                                        }}
                                    />
                                </Tooltip>

                            );
                        })
                    }
                </Geographies>
            </ComposableMap>
        </>
    )
}

export default memo(MapChart)
